import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ErrorToast } from '../../components';
import { getUserFromLS, setUserToLS } from '../../helpers/localstorage-helper';

export const setMavieMigrationModalChecked = createAsyncThunk(
  'auth/setMavieMigrationModalChecked',
  async (
    setTermsConditionsModal: (modal: boolean) => void,
    { rejectWithValue }
  ) => {
    try {
      await axios.put(`/user/set-mavie-migration-modal-checked`);

      setTermsConditionsModal(false);

      const user = getUserFromLS();

      const userForLs = {
        ...user,
        isMavieMigrationModalChecked: true
      };

      setUserToLS(userForLs);
    } catch (error: any) {
      ErrorToast(error.response.data.error);
      return rejectWithValue(error.response.data.error);
    }
  }
);
